var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    "data-name": "arrow-right",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58579 8.7071C9.97631 8.31658 9.97631 7.68341 9.58579 7.29289L6.5 4.2071C6.30474 4.01184 6.30474 3.69526 6.5 3.49999C6.69526 3.30473 7.01184 3.30473 7.20711 3.49999L11.3536 7.64644C11.5488 7.8417 11.5488 8.15828 11.3536 8.35355L7.20711 12.5C7.01185 12.6953 6.69526 12.6953 6.5 12.5C6.30474 12.3047 6.30474 11.9881 6.5 11.7929L9.58579 8.7071Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0715411c61da13ca1526d80de42d96d5.svg";
export { ForwardRef as ReactComponent };